import { fileVars } from 'tools/Files/graphql'
import gql from 'utils/gql'

import { postListVars } from 'libreon/Discuss/graphqlVars'

export const projectListValues = `
  id
  shortId
  title
  updatedAt
  insertedAt
  releasedAt
  visibility
  rating
  website
  format
  status
  avatar
  features
`

const projectLoadValues = `
  ${projectListValues}
  subtitle
  license
  summary
  myAccess
  tags {
    id
    tag {
      id
      type
      label
      info
      meta
      group {id label}
    }
  }
  members {
    id
    type
    roles
    user {
      id
      handle
      name
      lastSeen
      avatar
    }
  }
  files {
    ${fileVars}
  }
  data(types: ["profile", "purchase", "praise"]) {
    id
    type
    value
  }
  journeyActor {
    id
    type
    journeys {
      id
      shortId
      milestoneId
      updatedAt
      insertedAt
      journey {
        id
        name
        milestones {
          id
          name
          order
          meta
        }
      }
    }
  }
`

const pdBase = '{id shortId type name discuss { id summary }}'
const projectLoadDiscuss = `
pd(id: $discussId, type: $discussType) ${pdBase}
`

// OPS; and is broken
export const LIST_PROJECTS = gql`
  query listProjects($filter: InputProjectFilter!) {
    projects(filter: $filter) {
      status { success message total offset matching }
      results {... on Project {${projectListValues}}}
    }
  }
`

export const LOAD_PROJECT = gql`
  query loadProject($id: ShortId, $discussId: ShortId, $discussType: ProjectDiscussType) {
    projects(id: $id) {
      status {success message total matching}
      result { ... on Project {${projectLoadValues}${projectLoadDiscuss}}}
    }
  }
`

export const UPSERT_PROJECT = gql`
  mutation changeProject(
    $project: InputProject
    $data: InputMixedData
    $action: ChangeActions
    $club: InputProjectClub
    $member: InputProjectMember
    $id: UUID
  ) {
    changeProject(
      project: $project
      data: $data
      club: $club
      member: $member
      action: $action
      id: $id
    ) {
      status { success message }
      result {
        ... on Project {
          id
          shortId
        }
        ... on ProjectData {
          id
        }
        ... on ProjectMember {
          id
        }
      }
    }
  }
`

export const UPSERT_PROJECT_MEMBER = gql`
  mutation upsertProjectMember($projectId: ShortId!, $member: InputProjectMember!) {
    upsertProjectMember(projectId: $projectId, member: $member) {
      success reason meta result { ${projectLoadValues} pd ${pdBase} }
    }
  }
`

// export const REACTOR_CHALLENGES = gql`
//   query reactorChallenges($projectId: UUID) {
//     reactorChallenges(projectId: $projectId) {
//       id
//       name
//       explain
//       visible
//       context
//       links {
//         id
//         order
//         challengeId
//       }
//       triggers {
//         id
//       }
//       conditions
//       actions
//       completed
//       journal {
//         id
//         meta
//       }
//       meta
//     }
//   }
// `

export const LIST_PROJECT_POSTS = gql`
  query loadProject(
      $id: ShortId!
      $discussId: ShortId
      $discussType: ProjectDiscussType
      $order: DiscussOrder
      $limit: Int
      $afterId: UUID
      $visible: Boolean
  ) {
    projects(id: $id) {
      status { success message }
      result {
        ... on Project {
          id pd(id: $discussId, type: $discussType) {
            type name discuss {
              id summary posts (order: $order, limit: $limit, afterId: $afterId, visible: $visible) {
                ${postListVars}
              }
            }
          }
        }
      }
    }
  }
`
